import { ApprovalListHeader as Header } from "./Header";

export default Header;
